// assets/rg-timer.js
(function () {
  const KEY = 'rg_hold_cart_drawer';

  function initTimer(root) {
    if (!root || root.dataset.initialized === '1') return;
    root.dataset.initialized = '1';

    const holdMinutes = parseInt(root.getAttribute('data-minutes'), 10) || 10;
    const totalMs = holdMinutes * 60 * 1000;

    const minEl = root.querySelector('#rg-min');
    const secEl = root.querySelector('#rg-sec');
    const barEl = root.querySelector('#rg-bar');
    const noteEl = root.querySelector('#rg-note');

    function getDeadline() {
      try {
        const saved = sessionStorage.getItem(KEY);
        if (saved) {
          const t = parseInt(saved, 10);
          if (!Number.isNaN(t) && t > Date.now()) return t;
        }
      } catch (_) {}
      const next = Date.now() + totalMs;
      try { sessionStorage.setItem(KEY, String(next)); } catch (_) {}
      return next;
    }

    let deadline = getDeadline();

    function tick() {
      const now = Date.now();
      let remaining = deadline - now;

      if (remaining <= 0) {
        if (noteEl) {
          noteEl.classList.remove('show');
          // force reflow then show again for animation
          void noteEl.offsetWidth;
          noteEl.classList.add('show');
        }
        deadline = Date.now() + totalMs;
        try { sessionStorage.setItem(KEY, String(deadline)); } catch (_) {}
        remaining = totalMs;
      }

      const mins = Math.floor((remaining / 1000) / 60);
      const secs = Math.floor((remaining / 1000) % 60);

      if (minEl) minEl.textContent = String(mins).padStart(2, '0');
      if (secEl) secEl.textContent = String(secs).padStart(2, '0');

      if (barEl) {
        const pct = Math.max(0, Math.min(100, (remaining / totalMs) * 100));
        barEl.style.width = pct + '%';
      }
    }

    // Lightweight interval so it updates even in throttled tabs
    tick();
    const intervalId = setInterval(tick, 250);

    // When cart empties, reset storage and stop ticking
    document.addEventListener('cart:updated', function (e) {
      try {
        if (e && e.detail && typeof e.detail.item_count === 'number' && e.detail.item_count === 0) {
          sessionStorage.removeItem(KEY);
          clearInterval(intervalId);
        }
      } catch (_) {}
    }, { passive: true });
  }

  // Initialize any existing timers now
  function initAll() {
    document.querySelectorAll('.rg-hold:not([data-initialized="1"])').forEach(initTimer);
  }

  // Observe the DOM so timers created via AJAX also initialize
  const mo = new MutationObserver(() => initAll());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Bootstrap on ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // Also listen for common theme events
  ['shopify:section:load', 'cart:drawer:open', 'ajaxcart:loaded'].forEach(evt =>
    document.addEventListener(evt, initAll)
  );
})();